import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {ViewCashVo} from '../../common/shared/api/nicolas/vo/billing/ViewCashVo.interface';

/**
 * 사용자 캐시 정보 조회
 *
 * Origin: pageNicolasApi.getViewCash
 * API: POST /api/v5/store/view/cash
 */
export async function postStoreViewCash(
  options?: FetcherOptions
): Promise<ViewCashVo & ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v5/store/view/cash',
    {
      method: 'POST',
    },
    options
  );

  return response.data;
}
